import Banner from '@/components/Banner2';
import NewsTab from './components/NewsTab.vue';
export default {
  components: {
    Banner,
    NewsTab
  },
  data() {
    return {
      articleList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 10,
      loading: true,
      tabList: []
    };
  },
  created() {
    this.getNewsTypeList();
  },
  methods: {
    async getNewsTypeList() {
      const {
        result
      } = await this.$http.news.getNewsTypeList();
      this.tabList = result;
    }
  }
};